import type { ListRequest } from '../models/ApiModels';
import { fetchJson } from './http';

const LIST_URL = '/desktopmodules/List/Handlers/ListHandler.ashx';

export function submitListRequest<T = string>(request: ListRequest, recaptchaToken = ''): Promise<T> {
  return fetchJson<T>(LIST_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'g-recaptcha-response': recaptchaToken
    },
    body: JSON.stringify(request)
  });
}
